"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.gallery-wrapper {\n  border-top: 1px solid #d4d4d4; }\n  .gallery-wrapper .note-text {\n    padding-left: 3rem;\n    padding-top: 3rem; }\n  .gallery-wrapper .gallery {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center; }\n    .gallery-wrapper .gallery .container {\n      justify-content: center;\n      max-width: 850px;\n      padding-top: 1.5rem; }\n    .gallery-wrapper .gallery .bx--row {\n      margin: auto; }\n    .gallery-wrapper .gallery .item {\n      height: 1.5rem;\n      margin: 1.5rem;\n      object-fit: contain;\n      align-items: baseline; }\n    .gallery-wrapper .gallery a {\n      cursor: pointer; }\n";
  const fileName = "LogoGallery_LogoGallery";
  const element = document.querySelector("style[data-sass-component='LogoGallery_LogoGallery']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const LogoGallery = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gallery-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gallery"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--row container"
  }, props.items.map(i => {
    return /*#__PURE__*/_react.default.createElement("a", {
      key: i.description,
      target: "_blank",
      href: i.link
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "item",
      src: i.src,
      alt: `${i.description} Logo`,
      style: i.customStyle
    }));
  }))));
};
LogoGallery.propTypes = {
  items: _propTypes.default.array,
  translate: _propTypes.default.func
};
var _default = exports.default = LogoGallery;